"use client";
import React from "react";
import Link from "next/link";
import Image from "next/image";
import { refreshSearchFilter } from "@packages/lib/utlils/filters/result-filters";
const Breadcrumblayoutcomponent = ({ propsdata, clearing = false }: any) => {
  const filteredData = propsdata?.filter((breadcrumbData: any) => {
    if ("label" in breadcrumbData) {
      return breadcrumbData?.label && breadcrumbData?.label?.trim() !== "";
    } else {
      return breadcrumbData?.Imgurl && breadcrumbData?.Imgurl?.trim() !== "";
    }
  });

  if (!(filteredData?.length > 1)) return null;

  return (
    <nav aria-label="breadcrumb">
      <ul className="flex flex-wrap gap-[20px]">
        {filteredData?.map((breadcrumbData: any, idx: number) => (
          <li className="inter small" key={idx}>
            {breadcrumbData?.url && !breadcrumbData?.Imgurl ? (
              <Link
                className={`text-primary-400 hover:underline after:absolute ${filteredData?.length - 1 !== idx ? 'after:content-["/"]' : ""} after:w-[20px] after:h-[20px] after:text-center after:text-grey-300`}
                href={breadcrumbData?.url}
                onNavigate={() => refreshSearchFilter(breadcrumbData?.url)}
              >
                {breadcrumbData?.label}
              </Link>
            ) : breadcrumbData?.Imgurl && breadcrumbData?.url ? (
              <Link
                className='text-primary-400 hover:underline after:absolute after:content-["/"] after:w-[20px] after:h-[20px] after:text-center after:text-grey-300'
                href={breadcrumbData?.url}
                onNavigate={() => refreshSearchFilter(breadcrumbData?.url)}
              >
                <Image
                  src={breadcrumbData?.Imgurl}
                  width="17"
                  className="inline-block"
                  height="18"
                  alt="breadcrumb icon"
                />
              </Link>
            ) : (
              <span className="text-grey300">{breadcrumbData?.label}</span>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Breadcrumblayoutcomponent;
